export default ({ current = 0, max_events }) => ({
  current,
  max_events,

  showPreviousTimelineEvent() {
    if (this.current > 0) return (this.current = this.current - 1)
  },

  showNextTimelineEvent() {
    if (this.current < this.max_events) return (this.current = this.current + 1)
  },
})
